import React, { useState, useEffect } from 'react';

import { Disposition } from '../models/Disposition.model';
import { dogBreeds } from '../models/dogBreeds.data';
import { catBreeds } from '../models/catBreeds.data';
import { Species } from '../models/Species.model';
import './PetList.css'

const Search = ({handleSearch, handleResetSearchedArray}) => {
    const [searchValues, setSearchValues] = useState({
        dogBreed: '',
        catBreed: '',
        disposition: ''
    });

    const handleSubmit = e => {
        e.preventDefault();
        handleSearch(e, searchValues);
    };
    
    const handleChange = e => {
        const { name, value } = e.target;
        setSearchValues({
          ...searchValues,
          [name]: value
        });
      };
    
    const handleReset = () => {
        handleResetSearchedArray();
    };

    return (
        <div>
            <form onSubmit={handleSubmit} className='browser-form' noValidate>
              <div className='browser-label' >
                <Dropdown name={'dogBreed'} label={"Dog Breeds"} options={dogBreeds} onChange={handleChange} />
              </div>
              <div className='browser-label' >
                <Dropdown name={'catBreed'} label={"Cat Breeds"} options={catBreeds} onChange={handleChange} />
              </div>
              <div className='browser-label' >
                <Dropdown name={'disposition'} label={"Disposition"} options={Disposition} onChange={handleChange} />
              </div>  
                <button className='browse-input-btn' type='submit'>
                    Search
                </button>
                <button onClick={handleReset} className='browse-input-btn' type='reset'>
                    Reset
                </button>
            </form>
        </div>

    )
}
export default Search;

const Dropdown = ({ name, label, options, onChange }) => {
    return (
      <label>
        {label}
        <select name={name} id={label} onChange={(e) => onChange(e)}>
            <option key={"0"} value="" defaultValue disabled hidden>Choose here</option>      
            {options.map((option, index) => (
                <option key={index+1} value={option}>{option}</option>
            ))}
        </select>
      </label>
    );
};